import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';

const featuredSlugs = [
  '2048-core-architecture-deep-dive',
  '2048-core-ai-training-benchmark',
  '2048-core-datacenter-deployment',
  '2048-core-scientific-computing',
  'many-core-programming-model',
  '2048-core-memory-wall-solutions',
];

const articleImages: Record<string, string> = {
  '2048-core-architecture-deep-dive': 'https://readdy.ai/api/search-image?query=Futuristic%20abstract%20processor%20chip%20architecture%20with%20warm%20orange%20geometric%20patterns%2C%20minimalist%20tech%20aesthetic%2C%20clean%20dark%20background%20with%20subtle%20glowing%20lines%2C%20modern%20semiconductor%20design%20concept&width=800&height=400&seq=article-arch-01&orientation=landscape',
  '2048-core-ai-training-benchmark': 'https://readdy.ai/api/search-image?query=Abstract%20AI%20neural%20network%20visualization%20with%20warm%20orange%20and%20dark%20teal%20nodes%2C%20minimalist%20tech%20aesthetic%2C%20clean%20dark%20background%20with%20glowing%20connections%2C%20modern%20deep%20learning%20design%20concept&width=800&height=400&seq=article-ai-01&orientation=landscape',
  '2048-core-datacenter-deployment': 'https://readdy.ai/api/search-image?query=Futuristic%20data%20center%20server%20racks%20with%20warm%20orange%20accent%20lighting%2C%20minimalist%20tech%20aesthetic%2C%20clean%20geometric%20infrastructure%20design%2C%20modern%20cloud%20computing%20visual&width=800&height=400&seq=article-dc-01&orientation=landscape',
  '2048-core-scientific-computing': 'https://readdy.ai/api/search-image?query=Abstract%20climate%20simulation%20grid%20visualization%20with%20warm%20orange%20geometric%20patterns%2C%20minimalist%20tech%20aesthetic%2C%20clean%20dark%20background%2C%20modern%20scientific%20computing%20design&width=800&height=400&seq=article-sci-01&orientation=landscape',
  'many-core-programming-model': 'https://readdy.ai/api/search-image?query=Abstract%20parallel%20programming%20code%20blocks%20with%20warm%20orange%20and%20teal%20highlighting%2C%20minimalist%20tech%20aesthetic%2C%20clean%20dark%20background%20with%20geometric%20connections%2C%20modern%20coding%20design&width=800&height=400&seq=article-prog-01&orientation=landscape',
  '2048-core-memory-wall-solutions': 'https://readdy.ai/api/search-image?query=Abstract%20memory%20chip%20stack%20architecture%20with%20warm%20orange%20geometric%20patterns%2C%20minimalist%20tech%20aesthetic%2C%20clean%20dark%20background%20with%20glowing%20data%20flow%2C%20modern%20semiconductor%20design&width=800&height=400&seq=article-mem-01&orientation=landscape',
};

export default function FeaturedArticles() {
  const featuredArticles = articles.filter((a) => featuredSlugs.includes(a.slug));

  return (
    <section className="py-16 md:py-24 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between mb-12 gap-3">
          <div>
            <span className="inline-block px-3 py-1 bg-accent-100 text-accent-700 text-xs font-medium rounded-full mb-4">
              深度技术文章
            </span>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
              精选技术解析
            </h2>
          </div>
          <Link
            to="/categories"
            className="text-sm text-primary-500 hover:text-primary-600 font-medium transition-colors whitespace-nowrap flex items-center gap-1"
          >
            查看全部文章
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line"></i>
            </div>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {featuredArticles.map((article) => (
            <Link
              key={article.slug}
              to={`/articles/${article.slug}`}
              className="group bg-background-50 rounded-lg overflow-hidden transition-all duration-300 hover:bg-background-50/90 flex flex-col"
            >
              <div className="relative h-48 overflow-hidden">
                <img
                  src={articleImages[article.slug]}
                  alt={article.title}
                  title={article.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-5 flex flex-col flex-1">
                <div className="flex items-center gap-3 mb-3">
                  <span className="text-xs text-foreground-400">{article.date}</span>
                  <span className="text-xs text-foreground-300">·</span>
                  <span className="text-xs text-foreground-400">{article.readTime}</span>
                </div>
                <h3 className="font-heading font-semibold text-sm text-foreground-900 mb-2 leading-snug group-hover:text-primary-500 transition-colors line-clamp-2">
                  {article.title}
                </h3>
                <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2 mb-4 flex-1">
                  {article.excerpt}
                </p>
                <div className="flex flex-wrap gap-1.5">
                  {article.tags.slice(0, 3).map((tag) => (
                    <span
                      key={tag}
                      className="px-2 py-0.5 bg-secondary-100 text-secondary-700 text-xs rounded-full"
                    >
                      {tag}
                    </span>
                  ))}
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}